export default function InstagramIcon({ width = 20, height = 20, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 13 13"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M6.15755 9.3029C4.42171 9.3029 3.00977 7.89053 3.00977 6.15469C3.00977 4.41884 4.42171 3.00732 6.15755 3.00732C7.89348 3.00732 9.30585 4.41884 9.30585 6.15469C9.30585 7.89053 7.89348 9.3029 6.15755 9.3029ZM6.15755 3.85457C4.88922 3.85457 3.85702 4.88627 3.85702 6.15469C3.85702 7.4231 4.88922 8.45565 6.15755 8.45565C7.42639 8.45565 8.4586 7.4231 8.4586 6.15469C8.4586 4.88627 7.42639 3.85457 6.15755 3.85457Z"
                fill="#EAEAEA"
            />
            <path
                d="M9.7548 3.06379C9.97102 3.06379 10.1463 2.8885 10.1463 2.67227C10.1463 2.45605 9.97102 2.28076 9.7548 2.28076C9.53857 2.28076 9.36328 2.45605 9.36328 2.67227C9.36328 2.8885 9.53857 3.06379 9.7548 3.06379Z"
                fill="#EAEAEA"
            />
            <path
                d="M8.86426 12.3099H3.44568C1.54555 12.3099 0 10.7643 0 8.8646V3.44602C0 1.54555 1.54555 0 3.44568 0H8.86426C10.7644 0 12.3099 1.54555 12.3099 3.44602V8.8646C12.3099 10.7643 10.7644 12.3099 8.86426 12.3099ZM3.44568 0.847249C2.01306 0.847249 0.847249 2.01298 0.847249 3.44602V8.8646C0.847249 10.2969 2.01306 11.4627 3.44568 11.4627H8.86426C10.2969 11.4627 11.4627 10.2969 11.4627 8.8646V3.44602C11.4627 2.01298 10.2969 0.847249 8.86426 0.847249H3.44568Z"
                fill="#EAEAEA"
            />
        </svg>
    );
}
